"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformMangopayTimestampToDate = transformMangopayTimestampToDate;
function transformMangopayTimestampToDate(timestamp) {
    return timestamp ? new Date(Math.floor(timestamp) * 1000) : undefined;
}
//# sourceMappingURL=transformMangopayTimestampToDate.js.map